import { AmountUtils, cn, FormatUtils, PaletteUtils } from '@shared/utils';
import type { AccountResponse } from '@shared/api';
import { AccountManipulations } from './accountManipulations';
import { AccountDetails } from './accountDetails';
import { AccountsList } from './accountsList';
import { Text } from '@shared/widgets';
import styles from './accountPaymentTile.module.scss';

interface AccountPaymentTileProps {
  className?: string;
  account: AccountResponse;
  mainAccount?: AccountResponse;
  subAccounts?: AccountResponse[];
  withAccounts?: boolean;
  noHover?: boolean;
  selectedAccountId?: number;
  onSelectAccount?: (accountId: number) => void;
}

export const AccountPaymentTile = (props: AccountPaymentTileProps) => {
  return (
    <div
      className={cn(
        'group flex flex-col transition-shadow duration-200',
        PaletteUtils.isVcfcPalette && 'overflow-hidden rounded-xl dark:border dark:border-gray-black',
        !props.noHover && 'hover:shadow-lg dark:hover:shadow-lg-dark',
        !props.noHover && styles['account-payment-card'],
        props.className,
      )}
    >
      <div
        className={cn(
          'flex flex-row justify-between bg-black bg-cover bg-center bg-no-repeat px-5 py-3',
          styles['bg-account-payment'],
          PaletteUtils.isVcfcPalette && styles.vcfc,
          PaletteUtils.isPersonalPalette && '!bg-[linear-gradient(180deg,#4c171808_0%,#4C1718_100%)]',
        )}
      >
        <div className='flex flex-col'>
          <Text weight='semibold' color='white'>
            {props.account.name || FormatUtils.formatAccountNumber(props.account.accountNumber)}
          </Text>
          <Text uppercase size='xs' color='gray'>
            {props.account.productName}
          </Text>
        </div>
      </div>
      <div className={cn('flex h-full flex-col bg-white p-5 dark:bg-soft-black', !props.withAccounts && 'gap-3')}>
        <Text size='3xl'>{AmountUtils.transformToAmountWithCurrency(props.account.availableBalance ?? 0, props.account.currency)}</Text>
        {!props.withAccounts && (
          <AccountManipulations
            account={props.account}
            mainAccount={props.mainAccount}
            subAccounts={props.subAccounts}
            selectedAccountId={props.selectedAccountId}
            onSelectAccount={props.onSelectAccount}
          />
        )}
        <AccountDetails
          className={cn(!props.withAccounts ? ['flex gap-6', 'max-sm:flex-col'] : 'mt-2 flex flex-col gap-2')}
          account={props.account}
          withStatus={!props.withAccounts}
        />
        {props.withAccounts && !!props.subAccounts?.length && <AccountsList accounts={props.subAccounts} />}
      </div>
    </div>
  );
};
